/* eslint-disable */
import { Grid, IconButton, Snackbar, Tooltip, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import CloseIcon from '@material-ui/icons/Close';
import ColorizeIcon from '@material-ui/icons/Colorize';
import ErrorIcon from '@material-ui/icons/Error';
import SearchIcon from '@material-ui/icons/Search';
import StyleIcon from '@material-ui/icons/Style';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import docketsActionCreators from '../../State/Store/Dockets/Dockets.actions';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_ACCOUNT_PRODUCT_SELECTOR_SELECT_PRODUCT_CODE, UI_ACCOUNT_PRODUCT_SELECTOR_SELECT_PRODUCT_DESCRIPTION } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Autocomplete from '../Autocomplete/Autocomplete.component';
import Spinner from '../Spinner/Spinner.component';
import placeOrderStyles from './PlaceOrder.component.styles';
import PlaceOrderErrorMessage from './PlaceOrderErrorMessage.component';

// this is used to force Autocomplete copmponent to rerender without modifying Autocomplete itself. Long story short, in edge cases when code is selected and then description doesnt get repopulated as Autocomplete recognises this as already same as the new one from props.
let productContainerKey = Date.now();

/**
 * ProductSelector
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const ProductSelector = ({ actions, classes, services, onChange, defaultProduct, projectId, coordinates, locationCode, disabled, mandatoryFieldError }) => {
  const [productsLoading, setProductsLoading] = useState(false);
  const [products, setProducts] = useState(null);
  const [error, setError] = useState(false);
  const [loadingError, setLoadingError] = useState(false);
  const [filterText, setFilterText] = useState({ code: ``, description: `` });
  const [defaultValue, setDefaultValue] = useState(``);

  useEffect(() => {
    if (disabled) {
      return;
    }
    // request list of products from api
    setProductsLoading(true);
    (async () => {
      try {
        const loadedProducts = await services.orderService.getProducts({
          projectId,
          latitude: coordinates.lat,
          longitude: coordinates.lng,
          locationCode,
        });

        setProducts(loadedProducts);

        const product = defaultProduct.selectedProduct ? loadedProducts.find((el) => el.code.trim() === defaultProduct.selectedProduct.code.trim()) : null;
        if (product) {
          setDefaultValue({ code: product.code, description: product.description });
        } else {
          setDefaultValue({ code: ``, description: `` });
          onChange({ isValid: false, selectedProduct: null });
          setFilterText({ code: ``, description: `` });
        }
        productContainerKey = Date.now();
      } catch (ex) {
        setLoadingError(`Something went wrong while fetching available products`);
      }
      setProductsLoading(false);
    })();
  }, [coordinates, locationCode, projectId]);

  /**
   * Sets currently selected product and informs parent about changes
   * @param {string} productCode name of the account
   * @param {boolean} isDescriptionSelector description selector flag
   * @returns {void} void
   */
  const onSelectProductHandler = (productCode, isDescriptionSelector) => {
    if (isDescriptionSelector) {
      actions.uiTriggered({
        payload: {
          data: {
            name: `accountProductSelectorSelectProductDescription`,
          },
        },
        type: UI_ACCOUNT_PRODUCT_SELECTOR_SELECT_PRODUCT_DESCRIPTION,
      });
    } else {
      actions.uiTriggered({
        payload: {
          data: {
            name: `accountProductSelectorSelectProductCode`,
          },
        },
        type: UI_ACCOUNT_PRODUCT_SELECTOR_SELECT_PRODUCT_CODE,
      });
    }

    const product = products.find((el) => el.code.trim() === productCode);
    onChange({ isValid: true, selectedProduct: product });
    return;
  };

  /**
   * Renders dateTime selector
   * @param {Object} object object arguments
   * @returns {component} component
   */
  const renderProductSelector = ({ isDescriptionSelector, placeholder, endIcon, icon, helperText }) => {
    let prevSubheader = null;
    const optionsList = !products
      ? []
      : products
        .map((el, i, arr) => {
          const comp = {
            category: el.category,
            description: el.description.trim(),
            code: el.code.trim(),
            component: (
              <Tooltip title={`${el.code} - ${el.description}`} key={el.code}>
                <Grid container className={classes.flexWrapNowrap}>
                  <Grid item>
                    <StyleIcon className={classes.itemIcon} />
                  </Grid>
                  <Grid item>
                    <Grid container>
                      <Grid item xs={12}>
                        {el.description}
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="caption" className={classes.opacity05}>
                          Product Code: {el.code}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Tooltip>
            ),
          };
          return comp;
        })
        .filter((el) => {
          if (el.description && (filterText.code || filterText.description)) {
            // so if user has typed in abc for descriptions and 1234 for code then it will find
            // any elements where
            // code contains abc or 1234
            // or
            // description contains abc or 1234
            return (
              !!(filterText.code && el.code.toLowerCase().includes(filterText.code.toLowerCase())) ||
              !!(filterText.description && el.description.toLowerCase().includes(filterText.description.toLowerCase())) ||
              !!(filterText.code && el.description.toLowerCase().includes(filterText.code.toLowerCase())) ||
              !!(filterText.description && el.code.toLowerCase().includes(filterText.description.toLowerCase()))
            );
          }
          return true;
        })
        .map((el) => {
          if (prevSubheader !== el.category) {
            prevSubheader = el.category;
            return {
              ...el,
              subheader: el.category,
            };
          }
          return el;
        });

    let defaultAutocomleteValue = null;
    if (disabled) {
      defaultAutocomleteValue = isDescriptionSelector ? defaultProduct.product : defaultProduct.code;
    } else {
      defaultAutocomleteValue = isDescriptionSelector ? defaultValue.description.trim() : defaultValue.code.trim();
    }

    return products || disabled ? (
      <span key={productContainerKey}>
        <Autocomplete
          mandatoryFieldError={mandatoryFieldError}
          disabled={disabled}
          id={isDescriptionSelector ? `ProductDescriptionAutocomplete` : `ProductCodeAutocomplete`}
          menuItemClasses={classes.menuItem}
          onClear={() => {
            // setError(`No product found`);
            onChange({ isValid: false, selectedProduct: null });
          }}
          label={isDescriptionSelector ? `Product Description` : `Product code`}
          onBlur={(typedText) => {
            if (!products || disabled) {
              return;
            }
            const foundProduct = products.find((el) => filterText.code === el.code.trim() && filterText.description === el.description.trim());
            if (!typedText || (typedText && products && !foundProduct)) {
              // setError(`No product found`);
              onChange({ isValid: false, selectedProduct: null });
            } else {
              setError(null);
              productContainerKey = Date.now();
            }
          }}
          defaultValue={defaultAutocomleteValue}
          onSelect={(el) => {
            onSelectProductHandler(el.code, isDescriptionSelector);
            setError(null);
            setDefaultValue({ code: el.code, description: el.description });
            setFilterText({ code: el.code, description: el.description });
            productContainerKey = Date.now();
          }}
          onType={(e) => {
            let updatedFilterText = { code: e.target.value, description: filterText.description };
            if (isDescriptionSelector) {
              updatedFilterText = { code: filterText.code, description: e.target.value };
            }
            setFilterText(updatedFilterText);
          }}
          endIcon={endIcon}
          icon={icon}
          helperText={disabled ? `` : helperText}
          error={error}
          options={
            disabled
              ? [
                <Tooltip title={`${defaultProduct.code} - ${defaultProduct.selectedProduct}`} key={defaultProduct.code}>
                  {` `}
                  <Grid container className={classes.flexWrapNowrap}>
                    <Grid item>
                      <StyleIcon className={classes.itemIcon} />
                    </Grid>
                    <Grid item>
                      <Grid container>
                        <Grid item xs={12}>
                          {defaultProduct.selectedProduct}
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="caption" className={classes.opacity05}>
                            {defaultProduct.code}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Tooltip>,
              ]
              : optionsList
          }
          placeholder={placeholder}
          fullWidth
          // validateFor={/^[a-zA-Z0-9\s\-]*$/} // put regex here to validate keyboard input  if required
          isLoading={false}
        />
      </span>
    ) : null;
  };

  let renderedSelectors = null;
  if (productsLoading) {
    renderedSelectors = <Spinner />;
  } else if (!disabled && !productsLoading && !loadingError && (!products || !products.length)) {
    renderedSelectors = (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PlaceOrderErrorMessage
            message={
              <Typography variant="body2" className={classes.errorText}>
                This Project does not have any products that are available to be ordered online. Please{` `}
                <a
                  className={classes.errorText}
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                >
                  Call Boral
                </a>
                {` `}
                to place your order.
              </Typography>
            }
          />
        </Grid>
      </Grid>
    );
  } else {
    renderedSelectors = (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {renderProductSelector({
            isDescriptionSelector: true,
            icon: <StyleIcon />,
            endIcon: <SearchIcon />,
            placeholder: `No product selected`,
            helperText: `Select a product by its description. This will automatically fill in the product code below.`,
          })}
        </Grid>
        <Grid item xs={12}>
          {renderProductSelector({
            isDescriptionSelector: false,
            icon: <ColorizeIcon />,
            endIcon: <SearchIcon />,
            placeholder: `No product selected`,
            helperText: `Select a product by its code. This will automatically fill in the product description above.`,
          })}
        </Grid>
      </Grid>
    );
  }

  return (
    <React.Fragment>
      <Snackbar
        action={[
          <IconButton aria-label="Close" className={classes.close} color="inherit" key="close" onClick={() => setError(false)}>
            <CloseIcon />
          </IconButton>,
        ]}
        anchorOrigin={{
          horizontal: `left`,
          vertical: `bottom`,
        }}
        className={classes.snackbar}
        ContentProps={{ classes: { root: classes.error } }}
        message={
          <span className={classes.snackbarMessage} id="client-snackbar">
            <ErrorIcon className={classes.snackbarIcon} />
            {loadingError}
          </span>
        }
        open={!!loadingError}
      />

      {renderedSelectors}
    </React.Fragment>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
ProductSelector.propTypes = {
  actions: PropTypes.object.isRequired,
  services: PropTypes.object.isRequired,
  coordinates: PropTypes.object,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  defaultProduct: PropTypes.object,
  projectId: PropTypes.string,
  locationCode: PropTypes.string,
  disabled: PropTypes.bool,
};

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentDateTimeGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
          ...docketsActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(ProductSelector);
